import PublicNav from "../Components/PublicNav";
import Footer from "../Components/Footer";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: "We collect information you provide directly, including your name, email address, and payment information when you register or subscribe. When you connect your Google Business Profile, we receive OAuth tokens and your business profile data (reviews, location details) on your behalf.",
  },
  {
    title: "2. How We Use Your Information",
    body: "We use your information solely to provide and improve the RIRA service. This includes generating AI-powered insights from your review data, sending email alerts and digests you have opted into, and processing payments through our secure payment processor (Stripe).",
  },
  {
    title: "3. Data Sharing",
    body: "We do not sell, rent, or share your personal data with third parties for marketing purposes. We share data only with service providers necessary to operate RIRA (payment processing, AI inference, email delivery), and only to the extent required to perform those services.",
  },
  {
    title: "4. Data Security",
    body: "We use industry-standard security practices including HTTPS encryption, JWT-based authentication, and PBKDF2 password hashing. OAuth tokens for Google are stored securely and can be revoked at any time from your Settings page.",
  },
  {
    title: "5. Data Retention",
    body: "We retain your account data for as long as your account is active. You may request account deletion at any time by contacting us at rirareview@gmail.com. Upon deletion, your personal data and review data will be removed within 30 days.",
  },
  {
    title: "6. Cookies",
    body: "RIRA uses only essential cookies and local storage for authentication tokens. We do not use tracking cookies or third-party advertising cookies.",
  },
  {
    title: "7. Your Rights",
    body: "You have the right to access, correct, or delete your personal data at any time. To exercise these rights, contact us at rirareview@gmail.com.",
  },
  {
    title: "8. Changes to This Policy",
    body: "We may update this Privacy Policy from time to time. We will notify you of significant changes via email or a prominent notice on our website. Continued use of RIRA after changes constitutes acceptance of the updated policy.",
  },
  {
    title: "9. Contact",
    body: "If you have questions about this Privacy Policy, please contact us at rirareview@gmail.com.",
  },
];

function PrivacyPage() {
  return (
    <div className="lp-page">
      <PublicNav />

      <section className="ip-hero">
        <div className="ip-hero-inner">
          <div className="lp-section-label">Legal</div>
          <h1 className="ip-hero-title">Privacy Policy</h1>
          <p className="ip-hero-sub">Last updated: May 3, 2026</p>
        </div>
      </section>

      <section className="ip-section">
        <div className="ip-section-inner ip-legal-inner">
          {SECTIONS.map((s) => (
            <div key={s.title} className="ip-legal-section">
              <h2 className="ip-legal-h2">{s.title}</h2>
              <p className="ip-body">{s.body}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PrivacyPage;
